export enum MainType {
    ToDo = 0,
    Other = 30,
    Compliance = 40
}